export default [
  {
    path: '/main/arena/point-type',
    meta: {
      tag: 'list_arena_point_type',
      name: 'Tipo de ponto (Arena)',
      breadcrumb: 'Tipo de ponto (Arena)'
    },
    component: () => import(/* webpackChunkName: "arena-point-type-list" */ '@/views/main/settings/arena/point-type/Index.vue'),
    children: [
      {
        path: '',
        name: 'listarenapointtype',
        meta: {
          tag: 'list_arena_point_type',
          menu: 'settings',
          name: 'Tipo de ponto (Arena)'
        },
        component: () => import(/* webpackChunkName: "arena-point-type-list" */ '@/views/main/settings/arena/point-type/List.vue'),
      },
      {
        path: '/main/arena/point-type/add',
        name: 'addarenapointtype',
        meta: {
          tag: 'add_arena_point_type',
          menu: 'settings',
          name: 'Adicionar | Tipo de ponto (Arena)',
          breadcrumb: 'Adicionar Tipo de ponto (Arena)'
        },
        component: () => import(/* webpackChunkName: "arena-point-type-add" */ '@/views/main/settings/arena/point-type/Add.vue')
      },
      {
        path: '/main/arena/point-type/:id',
        name: 'editarenapointtype',
        meta: {
          tag: 'edit_arena_point_type',
          menu: 'settings',
          name: 'Editar | Tipo de ponto (Arena)',
          breadcrumb: 'Editar Tipo de ponto (Arena)'
        },
        component: () => import(/* webpackChunkName: "arena-point-type-edit" */ '@/views/main/settings/arena/point-type/Edit.vue')
      }
    ]
  }
]
